import React from 'react'
import { cn } from '@/lib/utils'
import type { Size } from '@/types'

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface SpinnerProps {
  size?: Size
  className?: string
  /** Accessible label for screen readers */
  label?: string
}

// ---------------------------------------------------------------------------
// Style maps
// ---------------------------------------------------------------------------

const SIZE_STYLES: Record<Size, string> = {
  sm: 'w-4 h-4 border-2',
  md: 'w-6 h-6 border-2',
  lg: 'w-8 h-8 border-[3px]',
}

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  className,
  label = 'Loading…',
}) => {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn('inline-flex items-center justify-center shrink-0', className)}
    >
      <span
        className={cn(
          'rounded-full border-current border-r-transparent animate-spin',
          SIZE_STYLES[size],
        )}
      />
      <span className="sr-only">{label}</span>
    </span>
  )
}

export default Spinner
